import {
	Button,
	Checkbox,
	createStyles,
	Divider,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormLabel,
	Grid,
	Radio,
	RadioGroup,
	TextField,
	Theme,
	Typography,
	WithStyles,
	withStyles,
} from '@material-ui/core'
import { grey } from '@material-ui/core/colors'
import PrevIcon from '@material-ui/icons/NavigateBefore'
import NextIcon from '@material-ui/icons/NavigateNext'
import classNames from 'classnames'
import moment from 'moment'
import React from 'react'
import { withTranslation } from 'react-i18next'
import InputMask from 'react-input-mask'

import Ethnicity from '../../../DataTypes/Ethnicity'
import Gender from '../../../DataTypes/Gender'
import Language from "../../../DataTypes/Language";
import { FormData, StateIDs, StateInitials } from '../../../DataTypes/PersonalInfoTypes'
import Race from '../../../DataTypes/Race'
import * as regexPatterns from '../../../services/utils/patterns'

import { validateAddress } from '../../../services/AddressValidation/addressValidation.service'

import DatePicker from '../../Templates/DatePicker/DatePicker'
import TextItem from '../FormTemplates/CustomTextItem/CustomTextItem'

import Modal from '@material-ui/core/Modal';
import { ActivityOrNull } from 'src/services/Auth/authentication.service'

interface PersonalInfoFormProps extends WithStyles<typeof styles> {
	next: () => void
	back: () => void
	updateParticipantHandler: (formData: FormData) => void
	participant: FormData,
  t:any,
  activity: ActivityOrNull
}

export const validateParticipantAddress = (inputAddress: FormData) => {
	let newParticipantData: {[k: string]: any} = inputAddress;
	console.log('typed address',newParticipantData);

	const input_address1 = (newParticipantData.address1 !== undefined)?newParticipantData.address1:'';
	const input_address2 = (newParticipantData.address2 !== undefined && newParticipantData.address2 !== "")?newParticipantData.address2:'';
	const input_city = (newParticipantData.city !== undefined)?newParticipantData.city:'';
	const input_state = (newParticipantData.state !== undefined)?newParticipantData.state:'';
	const input_zip = (newParticipantData.zip !== undefined)?newParticipantData.zip:'';
	//let requestBody = { "streetNumber": "4989", "streetName": "laurelglen lane","address_2": "","city": "highlands ranch","state": "co","zip": "80130"}
	let requestBody = { "streetNumber": "", "streetName": input_address1,"address_2": input_address2,"city": input_city,"state": input_state,"zip": input_zip}
	return validateAddress(requestBody);
}


export class PersonalInfoForm extends React.PureComponent<PersonalInfoFormProps> {

	private formRef: React.RefObject<HTMLFormElement> = React.createRef()
	private phoneInputRef: React.RefObject<HTMLFormElement> = React.createRef()
  private ssnInputRef: React.RefObject<HTMLFormElement> = React.createRef()


	validate = () => {
		const form = this.formRef.current

		return form ? form.reportValidity() : false
	}

	rand = () => {
		return Math.round(Math.random() * 20) - 10;
	}
	getModalStyle = () => {
		// const top = 50 + this.rand();
		// const left = 50 + this.rand();
		return {
			// top: `${top}%`,
			// left: `${left}%`,
			// transform: `translate(-${top}%, -${left}%)`,
			height: `auto`,
    		top: `200px`,
    		left: `750px`,
    		bottom: `auto`,
			width: `700px`,
    		right: `auto`
		};
	}
	modalStyle = this.getModalStyle();

	compareAddress = (outputAddress: JSON) => {
		const inputAddress = {
			...this.props.participant
		}
		let output: {[k: string]: any} = outputAddress;
		let hasAddressChanged = false;
		console.log('inpitaddss',inputAddress.address1);
		console.log('outputaddress',output.address);
		hasAddressChanged = (inputAddress.address1 !== undefined && output.address !== undefined && inputAddress.address1 !== output.address[0])? true:false;
		console.log('address1 changed?',hasAddressChanged);
		if(!hasAddressChanged){
			hasAddressChanged = (inputAddress.address2 !== undefined && inputAddress.address2 !== "" && output.address2 !== undefined && inputAddress.address2 !== output.address2[0])? true:false;
			console.log('address2 changed?',hasAddressChanged);
		}
		if(!hasAddressChanged){
			hasAddressChanged = (inputAddress.city !== undefined && output.city !== undefined && inputAddress.city.replace("\n","") !== output.city[0])? true:false;
			console.log('input city',inputAddress.city);
			console.log('output city',output.city[0]);
			console.log('city changed?',hasAddressChanged);
		}
		if(!hasAddressChanged){
			hasAddressChanged = (inputAddress.zip !== undefined && output.zip !== undefined && inputAddress.zip.replace("\n","") !== output.zip[0])? true:false;
			console.log('zip changed?',hasAddressChanged);
		}
		console.log('hasAddressChanged',hasAddressChanged);
		return hasAddressChanged;
	}

	handleAddressValidationFailure = (e: Error) => {
		console.log('error', e);
		return false;
	}
	
	setOpen = (flag: boolean) => {
		console.log('opening')
		//return flag;
		this.props.participant.modalIsOpen = true;
		this.props.updateParticipantHandler(this.props.participant);
	}

	handleClose = () => {
		this.props.participant.modalIsOpen = false;
		this.props.updateParticipantHandler(this.props.participant);
	}
	
	onYesClick = () => {
		this.props.participant.address1 = this.props.participant.updatedAddress;
		this.props.participant.address2 = this.props.participant.updatedAddress2
		this.props.participant.city = this.props.participant.updatedCity;
		this.props.participant.zip = this.props.participant.updatedZip;
		this.props.participant.isAddressVerified = true;
		this.handleClose();
	}

	onNoClick = () => {
		this.props.participant.isAddressVerified = true;
		this.handleClose();
	}

	onFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isFormValid = this.validate()
		if (isFormValid) {
			console.log('isAddressVerified',this.props.participant.isAddressVerified)
			if(!this.props.participant.isAddressVerified)
			{
				let newParticipantData = {
							...this.props.participant
						}
        console.log(`EnableAddressValidation = ${process.env.EnableAddressValidation}, type ${typeof process.env.EnableAddressValidation}`)
          let outputAddress = await validateParticipantAddress(newParticipantData);
          console.log(`outputAddress ${outputAddress}`)
          if(outputAddress){
            console.log(`outputAddress ${JSON.stringify(outputAddress)}`)
          }
          if(outputAddress.data){
          //outputAddresspromise.then(response => updatedAddress = response);
          if(outputAddress.data.error_code && outputAddress.data.error_code.length > 0 && outputAddress.data.error_code[0] !== " "){
            this.props.participant.addressError = outputAddress.data.message[0];
          if(outputAddress.data.error_string[0] == "Range Error")
            this.props.participant.addressError += ": " + "Please enter a valid address";
          else
            this.props.participant.addressError += ": " + outputAddress.data.error_string[0];
          console.log('error', this.props.participant.addressError);
          this.props.updateParticipantHandler(this.props.participant);
          }
          else if(this.compareAddress(outputAddress.data)){
            console.log('opening dialog')
            if(outputAddress.data.address !== undefined && outputAddress.data.address[0] !== 'undefined')
              this.props.participant.updatedAddress = outputAddress.data.address + '\n';
            if(outputAddress.data.address2 !== undefined && outputAddress.data.address2[0] !== 'undefined')
              this.props.participant.updatedAddress2 = outputAddress.data.address2 + '\n';
            if(outputAddress.data.city !== undefined && outputAddress.data.city[0] !== 'undefined')
              this.props.participant.updatedCity = outputAddress.data.city + '\n';
            if(outputAddress.data.zip !== undefined && outputAddress.data.zip[0] !== 'undefined')
              this.props.participant.updatedZip = outputAddress.data.zip + '\n';
            this.props.participant.addressError ="";
            this.props.updateParticipantHandler(this.props.participant);
            this.setOpen(true);
          }
          else{
            this.props.next();
          }
        }
        else{
          this.props.next();
        }
			}
			else
			{
				this.props.next();
			}
		}
	}


	handleInputChange = (field: string) => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData[field] = e.target.value;
		newParticipantData.isAddressVerified = false;
		this.props.updateParticipantHandler(newParticipantData);
	}

	handleEthnicitySelect = (e: React.ChangeEvent<{}>) => {
		const { value } = e.target as HTMLSelectElement;

		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.ethnicity = Ethnicity[value];
		this.props.updateParticipantHandler(newParticipantData);
	}

  handleLanguageSelect = (e: React.ChangeEvent<{}>) => {
    const { value } = e.target as HTMLSelectElement;

    const newParticipantData = {
      ...this.props.participant
    }
    newParticipantData.preferredLanguage = Language[value];
    this.props.updateParticipantHandler(newParticipantData);
  }

	handleGenderSelect = (e: React.ChangeEvent<{}>) => {
		const { value } = e.target as HTMLSelectElement;
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.gender = Gender[value];
		this.props.updateParticipantHandler(newParticipantData);
	}

	handleRadioSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData[name] = value;
		this.props.updateParticipantHandler(newParticipantData);
	}

	handleRaceSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { checked, value } = e.target
		const newParticipantData = {
			...this.props.participant
    }

		if (checked === true) {
			if (value === Race.NA.key) {
			  newParticipantData.races = [];
      } else {
        newParticipantData.races = newParticipantData.races.filter((r: Race) => {
          return r.key !== Race.NA.key;
        })
      }
      newParticipantData.races.push(Race[value]);
		} else {
			newParticipantData.races = newParticipantData.races.filter((r: Race) => {
				return r.key !== value;
			})
		}
		this.props.updateParticipantHandler(newParticipantData);
	}

	handleDateOfBirthChange = (date: Date) => {
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.dateOfBirth = date;
		this.props.updateParticipantHandler(newParticipantData);
	}

	toggleHomelessStatus = () => {
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.homeless = !newParticipantData.homeless;
		this.props.updateParticipantHandler(newParticipantData);
	}

	toggleAlienStatus = () => {
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.alien = !newParticipantData.alien;
		this.props.updateParticipantHandler(newParticipantData);
	}

	toggleMailingAddressStatus = () => {

		const sameAsHomeAddress = !this.props.participant.sameAsHomeAddress

		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.sameAsHomeAddress = sameAsHomeAddress;

		if(sameAsHomeAddress){
			newParticipantData.mailingAddress1 = newParticipantData.address1;
			newParticipantData.mailingAddress2 = newParticipantData.address2;
			newParticipantData.mailingCity = newParticipantData.city;
			newParticipantData.mailingState = newParticipantData.state;
			newParticipantData.mailingZip = newParticipantData.zip;
		}else{
			newParticipantData.mailingAddress1 = undefined;
			newParticipantData.mailingAddress2 = undefined;
			newParticipantData.mailingCity = undefined;
			newParticipantData.mailingState = StateIDs.RI;
			newParticipantData.mailingZip = undefined;
		}
		this.props.updateParticipantHandler(newParticipantData);
	}

	handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.phoneNumber = e.target.value;
		this.props.updateParticipantHandler(newParticipantData);
	}

	handleSSNChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newParticipantData = {
			...this.props.participant
		}
		newParticipantData.ssn = e.target.value;
		this.props.updateParticipantHandler(newParticipantData);
	}

	phoneMaskCustom = (props: any) => {
		return <InputMask {...props} ref={this.phoneInputRef} mask="999-999-9999" maskChar={null} />
	}

	SSNMaskCustom = (props: any) => {
		return <InputMask {...props} ref={this.ssnInputRef} mask="999-99-9999" maskChar={null} />
	}

  // RJRI-158: Removed isEnrollmentManager gate — exceptions driven by activity.serviceType
  isRequiredForWBL(){
    const {activity} =  this.props
    if(activity && activity.serviceType){
      if(['CAREER_EXPLORATION_ESSENTIAL_SKILLS'].includes(activity.serviceType)){
        return false
      }
    }
    return true
  }

  // RJRI-158: Removed isEnrollmentManager gate — exceptions driven by activity.serviceType
  isAddressFieldRequired = () => {
    const {activity,participant} =  this.props
    if(activity && activity.serviceType){
      if(['CAREER_EXPLORATION_ESSENTIAL_SKILLS'].includes(activity.serviceType)){
        return false
      }
    }
    return !participant.homeless
  }

  // RJRI-158: Removed isEnrollmentManager gate — exceptions driven by activity.serviceType
  isSSNRequired = () => {
    const { activity,participant } = this.props
    if(activity && activity.serviceType){
      if(['CAREER_EXPLORATION_ESSENTIAL_SKILLS','INTERNSHIPS_WORK_BASED_LEARNING'].includes(activity.serviceType)){
        return false
      }
    }
    return !participant.alien
  }

	render() {
		const { classes, participant, t } = this.props

		return (
			<div className={classes.root}>
				<form onSubmit={this.onFormSubmit} ref={this.formRef} className={classes.signUpForm} autoComplete="off">
					<Typography variant="h5">{t("personalInfoForm.sectionTitle")}</Typography>

					<div className={classNames(classes.sectionContainer, classes.personalInfoSection)}>
						<div className={classes.group} style={{ justifyContent: 'space-between' }}>
							<Grid container={true} spacing={16}>
								<Grid item={true} xs={12} md={5}>
									<TextItem
										label={t("personalInfoForm.label.first")}
										prop="firstName"
										value={this.props.participant.firstName || ""}
										required={true}
										onChange={this.handleInputChange}
										otherInputProps={{
											maxLength: 255,
											pattern: regexPatterns.name,
											autoFocus: true,
										}}
									/>
								</Grid>
								<Grid item={true} xs={12} md={2}>
									<TextItem
										label={t("personalInfoForm.label.middle")}
										value={participant.middleInitial || ""}
										prop="middleInitial"
										otherInputProps={{
											maxLength: 1,
											pattern: regexPatterns.singleLetter,
											title: t("personalInfoForm.validation.middle")
										}}
										onChange={this.handleInputChange}
									/>
								</Grid>
								<Grid item={true} xs={12} md={5}>
									<TextItem
										label={t("personalInfoForm.label.last")}
										prop="lastName"
										value={participant.lastName || ""}
										required={true}
										onChange={this.handleInputChange}
										otherInputProps={{
											maxLength: 255,
											pattern: regexPatterns.name,
										}}
									/>
								</Grid>
							</Grid>
						</div>

						<div className={classes.group} style={{ justifyContent: 'space-between' }}>
							<Grid container={true} spacing={16}>
								<Grid item={true} xs={12} md={5}>
									<DatePicker
										id="dob"
										required={this.isRequiredForWBL()}
										label={t("personalInfoForm.label.dob")}
										onChange={this.handleDateOfBirthChange}
										value={participant.dateOfBirth}
										minDate={moment().subtract(120, 'years').toDate()}
										maxDate={moment().subtract(10, 'years').toDate()}
									/>
								</Grid>
								<Grid item={true} xs={12} md={2} >
									<div className={classes.alianLabel}>
									<FormGroup row={true}>
										<FormControlLabel
											control={
												<Checkbox
													checked={participant.alien || false}
													onChange={this.toggleAlienStatus}
													color="primary"
													data-auto={'checkbox-for-alien'}
                          id="alien"
												/>
											}
											label={t("personalInfoForm.label.alien")}
										/>
								    </FormGroup>

									</div>
									
								</Grid>
								<Grid item={true} xs={12} md={5}>
									<TextField
                    id="ssn"
										required={this.isSSNRequired()}
										value={participant.ssn || ''}
										name="ssn"
										placeholder="XXX-XX-XXXX"
										margin="normal"
										fullWidth={true}
										label={t("personalInfoForm.label.ssn")}
										variant="outlined"
										InputProps={{
											inputProps: {
												title: t("personalInfoForm.validation.ssn"),
												className: classes.input,
												name: 'ssn',
												pattern: '^\\d{3}-?\\d{2}-?\\d{4}$',
												ref: this.ssnInputRef,
											},
											inputComponent: this.SSNMaskCustom,
										}}
										onChange={this.handleSSNChange}
									/>
									
								</Grid>
							</Grid>
						</div>				
						<div className={classes.group} style={{ justifyContent: 'space-between' }}>
							<FormControl className={classes.inputSelect} data-auto="gender group" required={this.isRequiredForWBL()}>
								<FormLabel component="label" className={classes.label}>
                  {t("personalInfoForm.label.gender")}:
								</FormLabel>
								<RadioGroup
									aria-label="gender"
									data-auto="gender"
									name="gender"
									className={classes.radioGroup}
									value={participant.gender ? participant.gender.key : ''}
                  onChange={this.handleGenderSelect}
								>
                  {Gender.all().map((item: Gender, index: number) => (
                    <FormControlLabel
                      key={index}
                      value={item.key}
                      control={<Radio id={`gender-${index}`} color="primary" data-auto={`radio-for-${item.label}`} required={this.isRequiredForWBL()} />}
                      label={t(item.label)}
                    />
                  ))}
								</RadioGroup>
							</FormControl>
							<FormControl className={classes.inputSelect} data-auto="ethnicity group" required={this.isRequiredForWBL()}>
								<FormLabel component="label" className={classes.label}>
                  {t("personalInfoForm.label.ethnicity")}:
								</FormLabel>
								<RadioGroup
									aria-label="ethnicity"
									data-auto="ethnicity"
									name="ethnicity"
									className={classes.radioGroup}
									value={participant.ethnicity ? participant.ethnicity.key : ''}
									onChange={this.handleEthnicitySelect}
								>
									{Ethnicity.all().map((item: Ethnicity, index: number) => (
										<FormControlLabel
											key={index}
											value={item.key}
											control={<Radio id={`ethnicity-group-${index}`} color="primary" data-auto={`radio-for-${item.label}`} required={this.isRequiredForWBL()} />}
											label={t(item.label)}
										/>
									))}
								</RadioGroup>
							</FormControl>
							<FormControl className={classes.inputSelect} data-auto="race group" required={this.isRequiredForWBL()}>
                  <FormLabel component="label" className={classes.label}>
                    {t("personalInfoForm.label.race")}:
                  </FormLabel>

                  {Race.all().map((item: Race, index: number) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          id={`race-group-${index}`}
                          color="primary"
                          checked={participant.races.indexOf(Race[item.key]) >= 0}
                          onChange={this.handleRaceSelect}
                          name={`race-${item.key}`}
                          value={item.key}
                          data-auto={`checkbox-for-${item.label}`}
                          required={this.isRequiredForWBL()?(participant.races === null || participant.races.length === 0):false}
                        />
                      }
                      label={t(item.label)}
                    />
                  ))}
              </FormControl>
              <FormControl className={classes.inputSelect} data-auto="language group" required={this.isRequiredForWBL()}>
                <FormLabel component="label" className={classes.label}>
                  {t("personalInfoForm.label.language")}:
                </FormLabel>
                <RadioGroup
                  aria-label="language"
                  data-auto="language"
                  name="language"
                  className={classes.radioGroup}
                  value={participant.preferredLanguage ? participant.preferredLanguage.key : ''}
                  onChange={this.handleLanguageSelect}
                >
                  {Language.all().map((item: Language, index: number) => (
                    <FormControlLabel
                      key={index}
                      value={item.key}
                      control={<Radio id={`language-${index}`} color="primary" data-auto={`radio-for-${item.label}`} required={this.isRequiredForWBL()} />}
                      label={t(item.label)}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
					</div>

					<Divider variant="middle" style={{ margin: '12px 0' }} />
					{this.props.participant.addressError===''?null:(
						<div>
							<p style={{color:'red'}}>{t("personalInfoForm.addressValidation.erorr")}</p>
							<Divider variant="middle" style={{ margin: '12px 0' }} />
						</div>
					)}
					
					<Grid container={true} spacing={16}>

						<Grid item={true} xs={12} md={6}>
							<Typography variant="h6" component="h3" align="center" data-auto="Main Address Label">
                {t("personalInfoForm.label.homeAddress")}
							</Typography>
							
							<FormGroup row={true}>
								<FormControlLabel
									control={
										<Checkbox
											checked={participant.homeless || false}
											onChange={this.toggleHomelessStatus}
											color="primary"
											data-auto={'checkbox-for-homeless'}
										/>
									}
									label={t("personalInfoForm.label.homeless")}
								/>
							</FormGroup>
							<div className={classes.group} data-auto="Main Address">

								<Grid container={true} spacing={16}>
									<Grid item={true} xs={12}>
										<TextItem
											required={this.isAddressFieldRequired()}
											label={t("personalInfoForm.label.addressLineOne")}
											prop="address1"
											value={participant.address1 || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 100,
												pattern: regexPatterns.name,
											}}
										/>
									</Grid>


									<Grid item={true} xs={12}>
										<TextItem
											label={t("personalInfoForm.label.addressLineTwo")}
											prop="address2"
											value={participant.address2 || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 100,
												pattern: regexPatterns.name,
											}}
										/>
									</Grid>

									<Grid item={true} xs={12}>
										<TextItem
											required={this.isAddressFieldRequired()}
											label={t("personalInfoForm.label.city")}
											prop="city"
											value={participant.city || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 45,
												pattern: regexPatterns.name,
											}}
										/>
									</Grid>

									<Grid item={true} xs={6}>
										<TextItem
											required={this.isAddressFieldRequired()}
											label={t("personalInfoForm.label.zip")}
											prop="zip"
											value={participant.zip || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 15,
												pattern: regexPatterns.zip,
												title: t("personalInfoForm.validation.zip"),
											}}
										/>
									</Grid>

									<Grid item={true} xs={6}>
										<TextItem
											isSelect={true}
											required={this.isAddressFieldRequired()}
											label={t("personalInfoForm.label.state")}
											prop="state"
											value={participant.state || StateIDs[StateIDs.RI]}
											onChange={this.handleInputChange}
											SelectProps={{
												native: true,
												MenuProps: {
													className: classes.menu,
												},
											}}
										>
											{StateInitials.map((stateId, index) => (
												<option key={index} value={stateId} data-auto={`state-${stateId}`}>
													{stateId}
												</option>
											))}
										</TextItem>
									</Grid>
								</Grid>
							</div>
						</Grid>

						<Grid item={true} xs={12} md={6}>
							<Typography variant="h6" component="h3" align="center" data-auto="Mailing Address Label">
								{t("personalInfoForm.label.mailingAddress")}
							</Typography>
							<FormGroup row={true}>
								<FormControlLabel
									control={
										<Checkbox
                      id="mailing-address-checkbox"
											checked={participant.sameAsHomeAddress || false}
											onChange={this.toggleMailingAddressStatus}
											color="primary"
											data-auto={'checkbox-for-same-as-home-address'}
										/>
									}
									label={t("personalInfoForm.label.sameAsHomeAddress")}
								/>
							</FormGroup>
							<div className={classes.group} data-auto="Main Address">
								<Grid container={true} spacing={16}>
									<Grid item={true} xs={12}>
										<TextItem
											label={t("personalInfoForm.label.mailingAddressLineOne")}
											prop="mailingAddress1"
											value={participant.mailingAddress1 || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 100,
												pattern: regexPatterns.name,
												disabled: !!participant.sameAsHomeAddress,
											}}
										/>
									</Grid>

									<Grid item={true} xs={12}>
										<TextItem
											label={t("personalInfoForm.label.mailingAddressLineTwo")}
											prop="mailingAddress2"
											value={participant.mailingAddress2 || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 100,
												pattern: regexPatterns.name,
												disabled: participant.sameAsHomeAddress,
											}}
										/>
									</Grid>

									<Grid item={true} xs={12}>
										<TextItem
											label={t("personalInfoForm.label.mailingCity")}
											prop="mailingCity"
											value={participant.mailingCity || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 45,
												pattern: regexPatterns.name,
												disabled: participant.sameAsHomeAddress,
											}}
										/>
									</Grid>

									<Grid item={true} xs={6}>
										<TextItem
											label={t("personalInfoForm.label.mailingZip")}
											prop="mailingZip"
											value={participant.mailingZip || ''}
											onChange={this.handleInputChange}
											otherInputProps={{
												maxLength: 15,
												pattern: regexPatterns.zip,
												disabled: participant.sameAsHomeAddress,
                        title: t("personalInfoForm.validation.mailingZip")
											}}
										/>
									</Grid>

									<Grid item={true} xs={6}>
										<TextItem
											isSelect={true}
											label={t("personalInfoForm.label.mailingState")}
											prop="mailingState"
											value={participant.mailingState || StateIDs[StateIDs.RI]}
											onChange={this.handleInputChange}
											SelectProps={{
												native: true,
												MenuProps: {
													className: classes.menu,
												},
											}}
											otherInputProps={{
												disabled: participant.sameAsHomeAddress,
											}}
										>
											{StateInitials.map((stateId, index) => (
												<option key={index} value={stateId} data-auto={`state-${stateId}`}>
													{stateId}
												</option>
											))}
										</TextItem>
									</Grid>
								</Grid>
							</div>
						</Grid>
					</Grid>

					<Divider variant="middle" style={{ margin: '12px 0' }} />

					<div className={classes.sectionContainer} data-auto="contact-details-section">
						<Typography variant="h6" component="h3" data-auto="contact-details-header">
							{t("personalInfoForm.label.contactDetails")}
						</Typography>

						<Grid container={true} spacing={16}>
							<Grid item={true} xs={12} md={6}>
								<TextItem
									label={t("personalInfoForm.label.emailAddress")}
									prop="email"
									value={participant.email || ''}
									onChange={this.handleInputChange}
									otherInputProps={{
										placeholder: 'example@domain.com',
										type: 'email',
									}}
								/>

								<Typography variant="caption" gutterBottom={true} style={{ color: grey[700] }}>
                  {t("personalInfoForm.emailConfirmationDiaglog")}
								</Typography>
							</Grid>

							<Grid item={true} xs={12} md={6}>
								<TextField
                  required={this.isRequiredForWBL()}
									fullWidth={true}
									label={t("personalInfoForm.label.phoneNumber")}
									id="phone-number"
									type="tel"
									margin="normal"
									placeholder="123-456-7890"
									value={participant.phoneNumber || ''}
									variant="outlined"
									onChange={this.handlePhoneNumberChange}
									InputProps={{
										inputProps: {
                      title: t("personalInfoForm.validation.phoneNumber"),
											name: 'phoneNumber',
											ref: this.phoneInputRef,
											pattern: regexPatterns.phone,
										},
										inputComponent: this.phoneMaskCustom,
									}}
								/>
							</Grid>
						</Grid>
					</div>

					<Divider variant="middle" style={{ margin: '12px 0' }} />

					<div className={classes.buttonContainer}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => {this.props.back();}}
							className={classes.button}
							data-auto="file-upload-back-button"
						>
							<PrevIcon className={classes.icon} />
              {t("common.goBack")}
						</Button>

						<Button
							disabled={false}
							variant="contained"
							color="primary"
							className={classes.button}
							data-auto="personal-info-next-button"
							type="submit"
						>
              {t("common.next")}
							<NextIcon className={classes.icon} />
						</Button>
					</div>
					
					{/* <div> */}
					<Modal
						aria-labelledby="simple-modal-title"
						aria-describedby="simple-modal-description"
						open={this.props.participant.modalIsOpen}
						onClose={this.handleClose}
					>
						<div style={this.modalStyle} className={classes.paper}>
							<h2>{t("personalInfoForm.addressValidation.modalHeader")}</h2>
							<div style={{width:'600px'}}>
								<div style={{color:'red',width:'230px',float:'left'}}>
								<p style={{marginTop:'0px'}}>
								{t("personalInfoForm.addressValidation.addressEntered")}:<br />
										{this.props.participant.address1}<br />

										{ this.props.participant.address2 != undefined && this.props.participant.address2 != '' && 
												(<p>{this.props.participant.address2}</p>)
										}	

										{this.props.participant.city}<br />
										{this.props.participant.zip}<br />
									</p>
								</div>
								<div style={{color:'green',width:'250px',marginLeft:'250px'}}>
									<p>
									{t("personalInfoForm.addressValidation.correctAddress")}:<br />
										{this.props.participant.updatedAddress}<br />

										{ this.props.participant.updatedAddress2 != '' && 
												(<p>{this.props.participant.updatedAddress2}</p>)
										}	

										{this.props.participant.updatedCity}<br />
										{this.props.participant.updatedZip}<br />
									</p>
								</div>
							</div><br></br><br></br>
							<div className={classes.buttonContainer} style={{justifyContent:'left'}}>
								<Button
									variant="contained"
									color="primary"
									onClick={this.onNoClick}
									className={classes.button}
								>{t("personalInfoForm.addressValidation.no")}
								</Button>

								<Button
									disabled={false}
									variant="contained"
									color="primary"
									className={classes.button}
									onClick={this.onYesClick}
								>{t("personalInfoForm.addressValidation.yes")}
								</Button>
							</div>
						</div>
					</Modal>
					{/* </div> */}
					
				</form>
			</div>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			width: '100%',
			padding: '3%',
		},
		signUpForm: {
			display: 'flex',
			flexDirection: 'column',
		},
		sectionContainer: {},
		personalInfoSection: {
			flexWrap: 'wrap',
		},
		input: {},
		icon: {
			fontSize: theme.typography.fontSize,
			marginRight: theme.spacing.unit,
		},
		group: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
		},
		dob: {
			flexBasis: '20%',
			minWidth: '250px',
			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
				minWidth: '100px',
			},
		},
		menu: {},
		buttonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		button: {
			marginLeft: `${theme.spacing.unit * 2}px`,
		},
		contactItem: {
			minHeight: '65px',
			flexBasis: '48%',

			[theme.breakpoints.down('sm')]: {
				flexBasis: '98%',
			},
		},
		inputSelect: {
			flexDirection: 'row',

			[theme.breakpoints.down('md')]: {
				flexDirection: 'column',
				marginTop: `${theme.spacing.unit * 2}px`,
				flexBasis: '50%',
			},

			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
			},
		},
		personalInfoItem: {},
		radioGroup: {
			flexDirection: 'row',
			[theme.breakpoints.down('md')]: {
				flexDirection: 'column',
			},
		},
		genderLabel: {
			alignSelf: 'center',
			marginRight: theme.spacing.unit * 5,

			[theme.breakpoints.down('md')]: {
				marginRight: theme.spacing.unit * 2,
			},
		},
		label: {
			alignSelf: 'center',
			marginRight: theme.spacing.unit * 5,

			[theme.breakpoints.down('md')]: {
				marginRight: theme.spacing.unit * 2,
			},
		},
		alianLabel:{
			padding: '16px 0px'
		},
		paper:{
			position: 'absolute',
			width: 450,
			backgroundColor: theme.palette.background.paper,
			boxShadow: theme.shadows[5],
			padding: '3%',
		},
	})

export default withTranslation()(withStyles(styles)(PersonalInfoForm))
